import { render } from "./nav_cart.vue?vue&type=template&id=810bd658"
import script from "./nav_cart.vue?vue&type=script&lang=js"
export * from "./nav_cart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__